var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16579 6.86701C1.01862 6.63449 0.966684 6.35285 1.02103 6.08204C1.07538 5.81123 1.23171 5.57265 1.45676 5.4171C5.4057 2.54468 10.1418 1 15 1C19.8582 1 24.5943 2.54468 28.5432 5.4171C28.7683 5.57265 28.9246 5.81123 28.979 6.08204C29.0333 6.35285 28.9814 6.63449 28.8342 6.86701L15.8861 27.5014C15.7922 27.6539 15.6616 27.7798 15.5066 27.867C15.3516 27.9542 15.1772 28 15 28C14.8228 28 14.6484 27.9542 14.4934 27.867C14.3384 27.7798 14.2078 27.6539 14.1139 27.5014L1.16579 6.86701Z",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C7.10277 7.41337 10.9895 6 15 6C19.0105 6 22.8972 7.41337 26 10",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3447 20.2514C18.7388 20.1384 18.1728 19.8998 17.6918 19.5548C17.2108 19.2097 16.828 18.7677 16.574 18.264C16.3199 17.7602 16.2016 17.2086 16.2285 16.6531C16.2554 16.0976 16.4267 15.5534 16.7287 15.064C17.0308 14.5747 17.4554 14.1535 17.9685 13.8342C18.4817 13.5148 19.0693 13.3061 19.6846 13.2245C20.2999 13.143 20.9259 13.1909 21.5128 13.3646C22.0996 13.5382 22.6311 13.8326 23.0649 14.2245",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.225C6.24017 13.6321 6.64325 13.1137 7.16584 12.7256C7.68844 12.3375 8.31077 12.0944 8.96582 12.0224C9.62088 11.9505 10.2839 12.0524 10.8834 12.3173C11.4829 12.5821 11.9962 12.9999 12.3682 13.5255C12.7401 14.0512 12.9565 14.6648 12.9941 15.3004C13.0317 15.936 12.8891 16.5695 12.5815 17.1326C12.274 17.6957 11.8133 18.1672 11.2489 18.4962C10.6845 18.8253 10.0379 18.9995 9.37858 19H9.14557",
    stroke: "#E1B168",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.f5e5b2eb5c7e30c4b36dfa9fe60473a8.svg";
export { ForwardRef as ReactComponent };